module.exports = __webpack_public_path__ + "static/assets/40075f6cc5e660b1b9a57e48f948a901.svg";